/*
 * @Author: Christion.Young
 * @Date: 2021-01-12 18:42:17
 * @LastEditors: Christion.Young
 * @LastEditTime: 2025-08-14 14:00:00
 * @Description: 工具出口 - 统一管理全局引用
 */
import ElementUI from "element-ui";
import FooterBar from "@/components/FooterBar";
import animate from "animate.css";
import VueLazyload from "vue-lazyload";

// 使用新的统一工具导出
import {
  EventBus,
  MessageUtil,
  installPermission,
  getLabel,
  tableDataPick,
  listToTree,
  deepClone,
  aesEncrypt,
  aesDecrypt,
} from "@/utils";

import "element-ui/lib/theme-chalk/index.css";
import "@/style/index.scss";

export default (Vue) => {
  // 注册全局组件
  Vue.component("FooterBar", FooterBar);

  // 挂载全局属性和方法
  Vue.prototype.$baseURL = "/api/"; // API基础路径
  Vue.prototype.$getLabel = getLabel; // list翻译方法
  Vue.prototype.$tableDataPick = tableDataPick; // table列隐显控制方法
  Vue.prototype.$listToTree = listToTree; // list转tree方法
  Vue.prototype.$clone = deepClone; // 深拷贝方法
  Vue.prototype.$aesEncrypt = aesEncrypt; // 加密
  Vue.prototype.$aesDecrypt = aesDecrypt; // 解密

  // 注册Vue插件
  Vue.use(EventBus); // 事件总线
  Vue.use(ElementUI); // Element UI组件库
  Vue.use(MessageUtil); // 统一消息提示工具
  Vue.use(animate); // 动画库
  Vue.use(installPermission); // 权限系统

  // 配置Vue懒加载
  Vue.use(VueLazyload, {
    //完全显示的时候加载
    preLoad: 1,
    //失败时显示的图片
    error: require("@/assets/error.png"),
    //加载时显示的GIF图
    loading: require("@/assets/loading.gif"),
    //尝试加载几次
    attempt: 1,
  });
};
